import { Reveal } from "@/components/common/Reveal";
import { Sprout, Compass, Heart } from "lucide-react";

const intro =
    "Allier performance agricole, bien-être animal et construction durable pour bâtir les exploitations de demain. Des bâtiments agricoles et équestres conçus autour du vivant.";

const pillars = [
    {
        icon: Compass,
        title: "Écoconstruction",
        text: "Géobiologie appliquée et ossature bois au service de lieux sains et durables.",
    },
    {
        icon: Heart,
        title: "Bien-être animal",
        text: "L'animal au coeur de chaque conception. Le fondement de notre démarche.",
    },
    {
        icon: Sprout,
        title: "Vision globale",
        text: "Comprendre l'exploitation comme un écosystème complet avant de concevoir.",
    },
];

export const Intro = () => (
    <section
        data-testid="intro-section"
        className="relative bg-rz-bg py-24 lg:py-32 px-6 md:px-12"
    >
        <div className="mx-auto max-w-[1400px]">
            <div className="grid gap-12 lg:grid-cols-12 lg:gap-16 items-end">
                <div className="lg:col-span-7">
                    <Reveal>
                        <span className="text-xs tracking-[0.22em] uppercase text-rz-sage font-semibold">
                            L'animal au coeur de notre conception
                        </span>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <h2 className="font-display mt-5 text-[clamp(2rem,4.5vw,3.4rem)] font-bold tracking-tight leading-[1.05] text-rz-ink">
                            Bâtir les exploitations de demain, autour du vivant.
                        </h2>
                    </Reveal>
                </div>
                <div className="lg:col-span-5">
                    <Reveal delay={0.2}>
                        <p className="text-base lg:text-lg leading-relaxed text-rz-ink-soft">
                            {intro}
                        </p>
                    </Reveal>
                </div>
            </div>

            <div className="mt-16 lg:mt-24 grid gap-6 md:grid-cols-3">
                {pillars.map((p, i) => (
                    <Reveal key={p.title} delay={0.1 * i}>
                        <div
                            data-testid={`pillar-card-${i}`}
                            className="group h-full rounded-2xl border border-black/5 bg-white p-8 transition-all duration-500 hover:-translate-y-1 hover:shadow-xl hover:shadow-rz-green/5"
                        >
                            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-rz-pale/40 text-rz-green transition-colors duration-300 group-hover:bg-rz-green group-hover:text-white">
                                <p.icon size={22} />
                            </span>
                            <h3 className="font-display mt-6 text-xl font-bold text-rz-ink">
                                {p.title}
                            </h3>
                            <p className="mt-3 text-sm leading-relaxed text-rz-ink-soft">
                                {p.text}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
